export default {
  UPDATE_FUTURE: 'UPDATE_FUTURE',
  UPDATE_BETSLIP_TICKET: 'UPDATE_BETSLIP_TICKET',
};
